module.exports = __webpack_public_path__ + "static/img/1.5_banner.1a8b0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/1.5代测序/1.5_banner.png
// module id = 0wpD
// module chunks = 16